import { Permiso } from "@/shared/types/permiso";
import { useAuthContext } from "../contexts/auth-context";

export default function useHasPermisos(...permisos: Permiso[]) {
    const { hasPermisos } = useAuthContext();
    return hasPermisos(...permisos);
}